import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./BestSellerBanner.css";

const slidesData = [
  {
    image: "https://wonder-theme-beauty.myshopify.com/cdn/shop/files/banner-wonder-4.jpg?v=1646045654&width=3000",
    badge: "BESTSELLER",
    brand: "BKIND",
    title: "Floral Face",
    description: "Sensitive skin? We've got you covered.",
    productId: "bkind-floral-face",
    textAlign: "center",
  },
  {
    image: "https://wonder-theme-beauty.myshopify.com/cdn/shop/files/slider_ver_-1.jpg?v=1644348717&width=3000",
    badge: "BESTSELLER",
    brand: "Mokosh",
    title: "Argan Oil",
    description: "Natural hair cosmetics by Mokosh",
    productId: "mokosh-argan-oil",
    textAlign: "left",
  },
  {
    image: "https://wonder-theme-beauty.myshopify.com/cdn/shop/files/mokosh-banner.jpg?v=1648815049&width=3000",
    badge: "BESTSELLER",
    brand: "Mokosh",
    title: "Smoothing Face Serum",
    description: "Discover the best products from Mokosh",
    productId: "mokosh-serum",
    textAlign: "left",
  },
];

const BestSellerBanner = () => {
  return (
    <div className="bestseller-slider">
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        slidesPerView={1}
        loop
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        navigation={{
          nextEl: ".slider-next",
          prevEl: ".slider-prev",
        }}
        pagination={{
          el: ".slider-pagination",
          clickable: true,
          renderBullet: (index, className) => {
            return `
              <span class="${className}">
                <span class="progress"></span>
              </span>
            `;
          },
        }}
      >
        {slidesData.map((slide, i) => (
          <SwiperSlide key={i}>
            <img src={slide.image} alt={`slide-${i}`} />
            <div className={`slide-content ${slide.textAlign === 'center' ? 'center' : ''}`}>
              {slide.badge && <span className="badge">{slide.badge}</span>}
              {slide.brand && <h3 className="brand-best">{slide.brand}</h3>}
              {slide.title && <h2 className="title-best">{slide.title}</h2>}
              {slide.description && <p className="description">{slide.description}</p>}
              {/* 🔸 Updated class name */}
              <Link to={`/product/${slide.productId}`} className="bestseller-shop-now-btn">
                SHOP NOW
              </Link>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <button className="slider-prev">
        <svg className="svg-icon" width="72" height="72" viewBox="0 0 72 72">
          <path d="M42 18L24 36L42 54" fill="none" stroke="currentColor" strokeWidth="2"/>
        </svg>
      </button>
      <button className="slider-next">
        <svg className="svg-icon" width="72" height="72" viewBox="0 0 72 72">
          <path d="M30 18L48 36L30 54" fill="none" stroke="currentColor" strokeWidth="2"/>
        </svg>
      </button>

      <div className="slider-pagination"></div>
    </div>
  );
};

export default BestSellerBanner;